import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar, Footer } from "@/components/Navbar";
import { Spinner } from "@/components/Brand";
import { api } from "@/lib/api";
import Home from "@/pages/Home";
import Categories from "@/pages/Categories";
import Tryouts from "@/pages/Tryouts";
import PackageDetail from "@/pages/PackageDetail";
import { LoginPage, RegisterPage } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Exam from "@/pages/Exam";
import Result from "@/pages/Result";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import UsersAdmin from "@/pages/admin/UsersAdmin";
import CategoriesAdmin from "@/pages/admin/CategoriesAdmin";
import SubjectsAdmin from "@/pages/admin/SubjectsAdmin";
import QuestionsAdmin from "@/pages/admin/QuestionsAdmin";
import PackagesAdmin from "@/pages/admin/PackagesAdmin";
import PackageForm from "@/pages/admin/PackageForm";
import PassingGradeAdmin from "@/pages/admin/PassingGradeAdmin";
import ExamSettingsAdmin from "@/pages/admin/ExamSettingsAdmin";
import ResultsAdmin from "@/pages/admin/ResultsAdmin";
import StatsAdmin from "@/pages/admin/StatsAdmin";
import PaymentsAdmin from "@/pages/admin/PaymentsAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";

const PublicLayout = () => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1"><Outlet context={{ settings }} /></main>
      <Footer settings={settings} />
    </div>
  );
};

const RequireAuth = ({ admin = false, children }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/kategori" element={<Categories />} />
            <Route path="/tryout" element={<Tryouts />} />
            <Route path="/tryout/:id" element={<PackageDetail />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/daftar" element={<RegisterPage />} />
            <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/riwayat" element={<RequireAuth><Dashboard initialTab="history" /></RequireAuth>} />
            <Route path="/profil" element={<RequireAuth><Profile /></RequireAuth>} />
            <Route path="/hasil/:id" element={<RequireAuth><Result /></RequireAuth>} />
          </Route>
          <Route path="/ujian/:id" element={<RequireAuth><Exam /></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth admin><AdminLayout /></RequireAuth>}>
            <Route index element={<Overview />} />
            <Route path="peserta" element={<UsersAdmin role="peserta" />} />
            <Route path="kategori" element={<CategoriesAdmin />} />
            <Route path="materi" element={<SubjectsAdmin />} />
            <Route path="bank-soal" element={<QuestionsAdmin />} />
            <Route path="paket" element={<PackagesAdmin />} />
            <Route path="paket/:id" element={<PackageForm />} />
            <Route path="passing-grade" element={<PassingGradeAdmin />} />
            <Route path="pengaturan-ujian" element={<ExamSettingsAdmin />} />
            <Route path="hasil" element={<ResultsAdmin />} />
            <Route path="statistik" element={<StatsAdmin />} />
            <Route path="pembayaran" element={<PaymentsAdmin />} />
            <Route path="pengaturan" element={<SettingsAdmin />} />
            <Route path="admin" element={<UsersAdmin role="admin" />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
